import { __decorate } from "tslib";
import { Prop, Mixins, Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import BaseCloseBtn from '@/components/v2/BaseCloseBtn';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import FacebookPagePosts from '@/plugins/graphql/queries/v2/affiliate/facebook-page-posts.gql';
import ActionButton from '@/components/action_button/Index.vue';
import PageListPaginator from '@/components/facebook/PageListPaginator.vue';
import { last } from 'lodash';
import TheAlert from '@/views/shared/TheAlert.vue';
let AffiliatePublicationDialog = class AffiliatePublicationDialog extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.selectedPost = null;
        this.fbPagePosts = null;
        this.loading = false;
        this.pagination = {};
        this.paginationLoading = true;
        this.afterCursors = [];
    }
    selectPost(post) {
        if (this.selectedPost === post) {
            // unselect the selected post
            this.selectedPost = null;
        }
        else {
            this.selectedPost = post;
        }
    }
    onToggleChanged(newValue) {
        if (newValue) {
            this.$apollo
                .query({
                query: FacebookPagePosts,
                variables: {
                    appUuid: this.appUuid,
                    after: null,
                    before: null,
                },
                fetchPolicy: 'network-only',
            })
                .then((result) => {
                const { data, paging } = result.data.fetchFacebookPagePosts;
                this.fbPagePosts = data;
                this.pagination = paging;
                this.loading = true;
            })
                .catch((error) => {
                this.errorNotification(error.message);
            });
        }
    }
    isSelectedPost(post) {
        return this.selectedPost === post;
    }
    humanReadableDate(date) {
        return moment(date).fromNow();
    }
    hidePublications() {
        this.fbPagePosts = null;
        this.loading = false;
        this.$emit('cancel');
    }
    formatMessage(message) {
        if (message) {
            return message.split('\n');
        }
        return [' '];
    }
    confirmPost() {
        if (this.selectedPost) {
            this.$emit('selectedPost', this.selectedPost);
            this.$emit('cancel');
        }
        else {
            this.errorNotification('Please select a post.');
        }
    }
    goToNextPage() {
        this.paginationLoading = false;
        this.afterCursors.push(this.pagination.cursors.after);
        this.$apollo
            .query({
            query: FacebookPagePosts,
            variables: {
                appUuid: this.appUuid,
                after: this.pagination.cursors.after,
                before: null,
            },
            fetchPolicy: 'network-only',
        })
            .then((result) => {
            const { data, paging } = result.data.fetchFacebookPagePosts;
            this.fbPagePosts = data;
            this.pagination = paging;
            this.paginationLoading = true;
        })
            .catch((error) => {
            this.errorNotification(error.message);
        });
    }
    goToPreviousPage() {
        this.paginationLoading = false;
        this.afterCursors.pop();
        this.$apollo
            .query({
            query: FacebookPagePosts,
            variables: {
                appUuid: this.appUuid,
                after: last(this.afterCursors),
                before: null,
            },
            fetchPolicy: 'network-only',
        })
            .then((result) => {
            const { data, paging } = result.data.fetchFacebookPagePosts;
            this.fbPagePosts = data;
            this.pagination = paging;
            this.paginationLoading = true;
        })
            .catch((error) => {
            this.errorNotification(error.message);
        });
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], AffiliatePublicationDialog.prototype, "toggle", void 0);
__decorate([
    Prop({ type: String, default: null })
], AffiliatePublicationDialog.prototype, "appUuid", void 0);
__decorate([
    Watch('toggle')
], AffiliatePublicationDialog.prototype, "onToggleChanged", null);
AffiliatePublicationDialog = __decorate([
    Component({
        components: {
            BaseCloseBtn,
            ActionButton,
            PageListPaginator,
            TheAlert,
        },
    })
], AffiliatePublicationDialog);
export default AffiliatePublicationDialog;
